import {Action} from "@ngrx/store";
import {ITask, ITasksListParam} from "../../models/tasks/tasks.interface";

export enum ETasksActions {
  GetTasksList = '[Tasks] Get Tasks List',
  GetTasksListSuccess = '[Tasks] Get Tasks List Success',
  GetTasksListFailure = '[Tasks] Get Tasks List Failure',

  GetTaskDetail = '[Tasks] Get Task Detail',
  GetTaskDetailSuccess = '[Tasks] Get Task Detail Success',
  GetTaskDetailFailure = '[Tasks] Get Task Detail Failure'

}
export class GetTasksList implements Action {
  public readonly type = ETasksActions.GetTasksList;
  //constructor(public payload: ITasksListParam) {}
}
export class GetTasksListSuccess implements Action {
  public readonly type = ETasksActions.GetTasksListSuccess;
  constructor(public payload: Array<ITask>){}
}
export class GetTasksListFailure implements Action {
  public readonly type = ETasksActions.GetTasksListFailure;

}
export class GetTaskDetail implements Action {
  public readonly type = ETasksActions.GetTaskDetail;
}
export class GetTaskDetailSuccess implements Action {
  public readonly type = ETasksActions.GetTaskDetailSuccess;
}
export class GetTaskDetailFailure implements Action {
  public readonly type = ETasksActions.GetTaskDetailFailure;
}
export type TasksActions =
  GetTasksList |
  GetTasksListSuccess |
  GetTasksListFailure |
  GetTaskDetail |
  GetTaskDetailSuccess |
  GetTaskDetailFailure;
